<template>
  <el-dialog
    width="650px"
    :visible="value"
    :before-close="hide"
    :lock-scroll="true"
    :close-on-click-modal="false"
    class="verify-desk"
  >
    <div class="wrapper">
      <div class="title">提示</div>
      <div class="subtitle">请您在新打开的页面上完成支付</div>
      <div class="content-item">支付完成前请不要关闭此窗口，并根据</div>
      <div class="content-item">您的支付情况进行选择</div>
      <div class="emtpy-item"></div>
      <div v-on:click="payDone" class="btn-item">已完成支付</div>
      <div v-on:click="backPaymentList" class="other-item">
        &lt;返回选择其他支付方式
      </div>
      <div class="split-item"></div>
      <div class="footer-item">
        支付遇到问题，请拨打客服电话：400-602-1010
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VerifyPaymentAction',
  props: ['value'],
  data() {
    return {
      showDialog: true
    }
  },
  computed: {},
  methods: {
    backPaymentList() {
      this.$emit('showPaymentList')
    },
    hide() {
      // this.showDialog = false
      this.$emit('input', false)
    },
    payDone() {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.verify-desk {
  ::v-deep {
    .el-dialog {
    }

    .el-dialog__header {
      padding-bottom: 0;
    }
  }
}

.title {
  text-align: center;
  font-size: 20px;
  color: #262626;
  line-height: 20px;
  font-weight: bold;
}

.subtitle {
  text-align: center;
  color: #262626;
  line-height: 16px;
  margin-top: 48px;
  margin-bottom: 28px;
  font-size: 16px;
}

.content-item {
  text-align: center;
  color: #858585;
  line-height: 14px;
  margin-top: 10px;
  font-size: 14px;
}

.emtpy-item {
  height: 80px;
}

.btn-item {
  height: 40px;
  width: 160px;
  height: 40px;
  background-color: #046bcc;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  color: #ffffff;
  border-radius: 5px;
  margin-left: 225px;
  cursor: pointer;
}

.other-item {
  margin-top: 28px;
  text-align: center;
  font-size: 14px;
  color: #046bcc;
  line-height: 14px;
  margin-bottom: 38px;
  cursor: pointer;
}

.split-item {
  height: 1px;
  background-color: #ebebeb;
  border: none;
  width: 450px;
  margin-left: 80px;
}

.footer-item {
  font-size: 14px;
  line-height: 14px;
  margin-top: 23px;
  text-align: center;
  color: #858585;
}
</style>
